import '@cg-groupit/cg-frontend-utilities/zodiak/icons/dist/zodiak-icons.css';
import '@cg-groupit/cg-frontend-utilities/zodiak/css/zodiak-primitive-vars.css';
import '@cg-groupit/cg-frontend-utilities/zodiak/css/zodiak-semantic-vars.css';

import '../scss/screen.scss';
import $ from 'jquery';
import { fadeInContentAnimation } from './fadeInContent';

// Fire without blocking — dmlm-toggle is a side-effect only import.
import(/* webpackChunkName: "dmlm-toggle" */ './dmlm-toggle').catch((e) =>
	console.log('error in dmlm-toggle import', e)
);

// Start the Global | EN selector straight away instead of 5th in the serial
// chain below: until its click handler is bound the toggle does nothing, which
// on a cold CDN edge was ~2-3s after page load. It has no side effects on import
// and no dependency on the other header chunks; this bundle loads in the footer
// after gsap, so the DOM and window.gsap are already available.
import(/* webpackChunkName: "header-lang" */ './headerLang')
	.then((headerLangToggle) => headerLangToggle.default())
	.catch((e) => console.log('error in header-lang import', e));

$(document).ready(async function () {
	fadeInContentAnimation();

	// headerConfig runs first: subsequent header scripts depend on the CSS
	// variables and wrapper classes it sets up.
	try {
		const headerConfigDefault = await import(
			/* webpackChunkName: 'header-config' */ './headerConfig'
		);
		const headerConfig = new headerConfigDefault.default();
		headerConfig.setupDefaultHeaderWrapperClasses();
		headerConfig.setCssVariablesForHeader();
	} catch (e) {
		console.log(e);
	}

	//Do not remove the comment webpackChunkName as it sets the name of split chunk
	try {
		const headerMenuDropdownAnimation = await import(
			/* webpackChunkName: "header-menu-dropdown-anim" */
			'./headerMenuDropdownAnim'
		);
		headerMenuDropdownAnimation.default();
	} catch (e) {
		console.log(e);
	}

	try {
		const headerScrollAnimation = await import(
			/* webpackChunkName: "header-scroll-anim" */
			'./headerScrollAnim'
		);
		headerScrollAnimation.default();
	} catch (e) {
		console.log(e);
	}

	try {
		await import(
			/* webpackChunkName: "mobile-menu" */
			'./mobileMenu'
		);
	} catch (e) {
		console.log(e);
	}

	try {
		await import(
			/* webpackChunkName: "mobile-layout" */
			'./mobile-layout'
		);
	} catch (e) {
		console.log(e);
	}

	try {
		await import(
			/* webpackChunkName: "themeAccessibility" */
			'./themeAccessibility'
		);
	} catch (e) {
		console.log(e);
	}

	try {
		//Do not remove the comment webpackChunkName as it sets the name of split chunk
		import(
			/* webpackChunkName: "linkedinsharefix" */
			'./linkedinShareFix'
		);

		//Do not remove the comment webpackChunkName as it sets the name of split chunk
		import(
			/* webpackChunkName: "facebooksharefix" */
			'./facebookShareFix'
		);

		//Do not remove the comment webpackChunkName as it sets the name of split chunk
		import(
			/* webpackChunkName: "twittersharefix" */
			'./twitterShareFix'
		);
	} catch (e) {
		console.log(e);
	}

	try {
		await import(
			/* webpackChunkName: "header-search" */
			'./headerSearch'
		);
	} catch (e) {
		console.log(e);
	}

	try {
		await import(
			/* webpackChunkName: "archive-filter-expands" */
			'./archiveFilterExpands'
		);
	} catch (e) {
		console.log(e);
	}

	try {
		const searchFiltersLoader = await import(
			/* webpackChunkName: "search-filters-loader" */
			'./searchFiltersLoader'
		);
		searchFiltersLoader.default();
	} catch (e) {
		console.log(e);
	}
	try {
		await import(
			/* webpackChunkName: "custom-class-tmap" */
			'./customClassTmap'
		);
	} catch (e) {
		console.log('error in customClassTmap import', e);
	}
});
